import script from "./transportInvoiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./transportInvoiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./transportInvoiceDetail.vue?vue&type=style&index=0&id=c6d09e3c&lang=less"

const __exports__ = script;

export default __exports__